module.exports = __webpack_public_path__ + "img/t1.7ba8085e.svg";